import CircularProgress from "@mui/material/CircularProgress";
import classNames from "classnames/bind";
import ModalLoader from "../../../../assets/modal_loader.svg?react";
import styles from "./ProgressCard.module.scss";
import { Typography } from "@mui/material";

const cx = classNames.bind(styles);

/**
 * Base Component to render a Progress Card with a circular Progress indicator
 * @param
 * @returns
 */
export default function ProgressCard({
    value = 0,
    image: Image = ModalLoader,
    title = "",
    subTitle = "",
    currentStep = 1,
    totalStep = 1,
    showStep = false,
}) {
    return (
        <div className={cx("ProgressCard")}>
            <div className={cx("ImageContainer")}>
                <CircularProgress
                    variant="determinate"
                    value={100}
                    size={100}
                    thickness={1.8}
                    classes={{ root: cx("CircleProgressBarBg") }}
                />
                <CircularProgress
                    variant="determinate"
                    value={value}
                    size={100}
                    thickness={1.8}
                    classes={{ root: cx("CircleProgressBar") }}
                />
                <Image className={cx("Image")} width={60} height={60} />
            </div>
            {showStep && (
                <div className={cx("StepCount")}>
                    {currentStep} of {totalStep}
                </div>
            )}
            <Typography variant="typography2" className={cx("Title")}>
                {title}
            </Typography>
            {subTitle && (
                <Typography
                    variant="typography9"
                    className={cx("Title", "SubTitle")}
                >
                    {subTitle}
                </Typography>
            )}
        </div>
    );
}
